// @flow
import {
  ADMIN_UPDATE_QUOTE_LIST,
  ADMIN_DELETE_QUOTE_ITEM,
  ADMIN_GET_QUOTE_COMPANY_LIST,
  ADMIN_UPDATE_PRODUCT_SHEET_LIST,
  ADMIN_GET_SHEET_COMPANY_LIST,
  ADMIN_GET_QUOTE_LIST
} from "../../global/actions/actionNames";

const initialState = {
  quotes: null,
  companies: null,
  productSheets: null,
  sheetCompanies: null
};

const quoteReducers = (state: * = initialState, actions: *): * => {
  switch (actions.type) {
    case ADMIN_GET_QUOTE_LIST:
      if (actions.quotes !== null) {
        return {
          ...state,
          quotes: [...actions.quotes]
        };
      }

    case ADMIN_UPDATE_QUOTE_LIST:
      if (actions.quote !== null && actions.quote.id !== null) {
        let quotes = state.quotes === null ? [] : [...state.quotes];
        if (quotes.length > 0) {
          let index = quotes.findIndex(x => x.id === actions.quote.id);
          if (index > -1) {
            quotes[index] = actions.quote;
          } else {
            quotes.push(actions.quote);
          }
        } else {
          quotes.push(actions.quote);
        }

        return {
          ...state,
          quotes: quotes
        };
      }
      return state;

    case ADMIN_DELETE_QUOTE_ITEM:
      if (actions.quoteId !== null && state.quotes !== null) {
        let quotes = [...state.quotes];
        if (quotes.length > 0) {
          let index = quotes.findIndex(x => x.id === actions.quoteId);
          if (index > -1) {
            quotes.splice(index, 1);
          }
        }

        return {
          ...state,
          quotes: quotes
        };
      }
      return state;

    case ADMIN_GET_QUOTE_COMPANY_LIST:
      if (actions.companyId !== null && actions.children !== null) {
        let companies = { ...state.companies };
        companies[actions.companyId] = actions.children;

        return {
          ...state,
          companies: companies
        };
      }
      return state;

    case ADMIN_UPDATE_PRODUCT_SHEET_LIST:
      if (actions.productSheet !== null) {
        let productSheets =
          state.productSheets === null ? [] : [...state.productSheets];
        if (productSheets.length > 0) {
          let index = productSheets.findIndex(
            x => x.id === actions.productSheet.id
          );
          if (index > -1) {
            productSheets[index] = actions.productSheet;
          } else {
            productSheets.push(actions.productSheet);
          }
        } else {
          productSheets.push(actions.productSheet);
        }

        return {
          ...state,
          productSheets: productSheets
        };
      }
      return state;

    case ADMIN_GET_SHEET_COMPANY_LIST:
      if (actions.productSheets !== null) {
        return {
          ...state,
          sheetCompanies: [...actions.productSheets]
        };
      }
      return state;

    default:
      return state;
  }
};
export default quoteReducers;
